import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
let ModalMixin = class ModalMixin extends Vue {
    multiple = false;
    currentModalId = null;
    model = {};
    modal() {
        this.$root.$emit('bv::show::modal', this.currentModalId);
        return new Promise((resolve, reject) => {
            this.$root.$on('bv::hide::modal', (closedModalId) => {
                if (closedModalId == this.currentModalId) {
                    resolve(this.model);
                }
            });
        });
    }
    openModal(properties) {
        this.currentModalId = properties.id;
        this.multiple = properties.multiple || false;
        this.model = properties.model || {};
        return this.modal();
    }
    invoiceModal(invoiceId, print, preview = false, previewData = {}) {
        let details = {
            invoiceId: invoiceId,
            print: print,
            preview,
            previewData,
            _id: 'temp'
        };
        const { Invoice } = this.$FeathersVuex;
        new Invoice(details);
        this.openModal({
            id: 'InvoiceModal'
        });
    }
};
ModalMixin = __decorate([
    Component({})
], ModalMixin);
export default ModalMixin;
